import { render, staticRenderFns } from "./levelsStatsticTables.vue?vue&type=template&id=38726a72&scoped=true"
import script from "./levelsStatsticTables.vue?vue&type=script&lang=js"
export * from "./levelsStatsticTables.vue?vue&type=script&lang=js"
import style0 from "./levelsStatsticTables.vue?vue&type=style&index=0&id=38726a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38726a72",
  null
  
)

export default component.exports